import React from "react";

const SettlementFilters = () => {

    return (

        <div className="settlement-filters">

            <input
                type="text"
                placeholder="Search Provider..."
            />

            <select>

                <option>All Status</option>

                <option>Pending</option>

                <option>Processing</option>

                <option>Completed</option>

                <option>Rejected</option>

            </select>

            <select>

                <option>Payment Method</option>

                <option>Bank Transfer</option>

                <option>UPI</option>

            </select>

            <input type="date" />

            <input type="date" />

            <button>

                Filter

            </button>

        </div>

    );

};

export default SettlementFilters;